const getDocumentElement = () => document.documentElement

export const requestFullscreenMode = async () => {
  try {
    const documentElement = getDocumentElement()
    if (documentElement.webkitRequestFullscreen) {
      await documentElement.webkitRequestFullscreen()
      return
    }

    if (documentElement.requestFullscreen) {
      await documentElement.requestFullscreen()
      return
    }

    throw new Error('fullscreen request is not available')
  } catch (error) {
    console.log(error)
  }
}

export const exitFullscreenMode = async () => {
  try {
    if (document.webkitExitFullscreen) {
      await document.webkitExitFullscreen()
      return
    }

    if (document.exitFullscreen) {
      await document.exitFullscreen()
      return
    }

    throw new Error('fullscreen exit is not available')
  } catch (error) {
    console.log(error)
  }
}

export const toggleFullscreenMode = (isFull) => {
  const documentElement = getDocumentElement()
  if (!document.fullscreenEnabled && !documentElement.webkitRequestFullscreen) {
    return false
  }

  const fullscreenElement =
    document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement

  if (isFull && !fullscreenElement) {
    requestFullscreenMode()
  }

  if (!isFull && fullscreenElement) {
    exitFullscreenMode()
  }

  return true
}
